import $ from 'jquery';

$('.network-partners__more-link').on('click',function (e) {
  e.preventDefault();
  $(this).toggleClass('network-partners__more-link--active');
  $(this).siblings('.network-partners__more-text').toggleClass('network-partners__more-text--show');
})